<template>
  <div>
    <page-content-toolbar
      :projectName="`${project && project.name ? project.name : ' '}`"
      :title="$t('scenario.addOptionsToExistingScenario')"
    />

    <div
      v-if="!scenario"
       class="px-12 pt-7 pb-1 mt-2"
    >
      <v-alert
        dense
        type="info"
      >
        {{ $t('scenario.noScenarioFound') }}
      </v-alert>
    </div>
    <div
      v-else
    >
      <div class="px-12 pt-7 pb-1 mt-2">
        <scenario-block
          v-if="!loadingScenarios"
          @changeScenario="changeScenario($event)"
          :scenario="scenario"
          :scenarios="scenarios"
          v-on="$listeners"
        />
        <v-progress-circular
          v-else-if="loadingScenarios"
          size="55"
          width="6"
          class="d-block mx-auto"
          indeterminate
          color="primary"
        />
      </div>

      <v-container
        fluid
        class="px-12 pt-0"
      >
        <!-- selected option -->
        <option-block
          v-show="!loadingScenarios"
          :list-label="optionsAreValidated ? $t('scenario.possibleOptions') : $t('option.favorites')"
          :options="[...preferedOptions, ...validatedOptions]"
          :editable="optionsAreValidated"
          :edit-function="editValidatedOptions"
          :loading="loadingScenarioPreferences"
          :close="!optionsAreValidated && moreThanOneOptionIsPreferred"
          :close-function="removePreferedOption"
        />
        <v-row
          v-show="!optionsAreValidated"
          dense
          class="elevation-1 px-4 mx-2 py-4 my-5 grey lighten-2"
        >
          <v-progress-circular
            v-if="loadingOptions"
            size="55"
            width="6"
            class="d-block mx-auto"
            indeterminate
            color="primary"
          />
          <template v-else>
            <v-col cols="12">
              <h3 class="pa-3">{{ $t('scenario.selectOtherPossibleOptions') }}:</h3>
            </v-col>
            <v-col cols="12">
              <v-chip
                @click="resetOptions"
                link
                color="primary"
                :outlined="!toggleNone"
                label
                class="px-6 pt-0 mr-3 my-1"
                :disabled="scenario.extend === 'false'"
              >
                {{ $t('global.none') }}
              </v-chip>
              <option-chip
                v-for="option in availableOptions"
                :key="option.id"
                @click.native="toogleOption(option)"
                :outlined="!selectedOptions.includes(option)"
                link
                :option="option"
                :disabled="scenario.extend === 'false'"
              />
            </v-col>
          </template>
        </v-row>
        <v-row
          no-gutters
          justify="center"
        >
          <v-col cols="1" class="mx-2">
            <raison-button
              v-show="!optionsAreValidated"
              :button-label="$t('global.validate')"
              :button-function="validateSelectedoptions"
              :loading="callingApi"
            >
              <template v-slot:append>
                <v-icon right>mdi-arrow-right</v-icon>
              </template>
            </raison-button>
            <raison-button
              v-show="optionsAreValidated"
              :button-label="$t('scenario.nextScenario')"
              :button-function="goToNextScenario"
              :disabled="noMoreNextScenario"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
    <footer-navigation
      :prev-button-function="backToAddMinimalScenarii"
      prev-button-label="scenario.addMinimalScenarii"
      :next-button-function="goToIdentifyContradictoryOptions"
      next-button-label="option.identifyContradictoryOptions"
    />
  </div>
</template>

<script>
import PageContentToolbar from '@/components/layout/PageContentToolbar';
import ScenarioBlock from '@/components/global/ScenarioBlock';
import OptionBlock from '@/components/global/OptionBlock';
import RaisonButton from '@/components/global/RaisonButton';
import OptionChip from '@/components/global/OptionChip';
import FooterNavigation from '@/components/layout/FooterNavigation';

import projectPageMixin from '@/mixins/project-page-mixin.js';

import scenarioService from '@/services/scenarios.js';
import optionService from '@/services/options.js';
import _ from 'lodash';
import list from '@/utils/list.js';

export default {
  name: 'SetUpScenario',

  components: { FooterNavigation, PageContentToolbar, ScenarioBlock, OptionBlock, RaisonButton, OptionChip },

  mixins: [ projectPageMixin ],

  data () {
    return {
      loadingScenarios: false,
      loadingOptions: false,
      loadingScenarioPreferences: false,
      preferedOptions: [],
      scenario: {},
      scenarios: [],
      minimalPreferences: [],
      options: [],
      complementOptions: [],
      selectedOptions: [],
      validatedOptions: [],
      toggleNone: false,
      optionsAreValidated: false,
      callingApi: false,
    };
  },

  computed: {
    noMoreNextScenario () {
      return this.currentScenarioIndex >= this.scenarios.length - 1
    },
    
    currentScenarioIndex() {
      const isCurrentScenario = (sce) => sce.id === this.scenario.id
      return this.scenarios.findIndex(isCurrentScenario)
    },

    availableOptions () {
      const preferedOptionsIds = this.preferedOptions.map(opt => opt.id);
      return this.options.filter(opt => !preferedOptionsIds.includes(opt.id));
    },

    moreThanOneOptionIsPreferred () {
      return this.preferedOptions.length > 1;
    },

    // Find preferences related to the selected scenario
    scenarioPreferences() {
      return this.minimalPreferences
        .filter(pref => pref.scenario.id === this.scenario.id);
    }
  },

  methods: {

    goToNextScenario() {
      this.scenario = this.scenarios[this.currentScenarioIndex + 1];
      this.changeScenario(this.scenario);
    },

    goToIdentifyContradictoryOptions () {
      this.$router.push({name: 'identifyContradictoryOptions', params: { id: this.$route.params.id }});
    },

    backToAddMinimalScenarii () {
      this.$router.push({name: 'addScenarii', params: { id: this.$route.params.id }});
    },

    reinit () {
      this.callingApi = false;
      this.toggleNone = false;
      this.optionsAreValidated = false;
      this.selectedOptions.length = 0;
      this.validatedOptions.length = 0;
    },

    toogleOption (option) {
      const idx = this.selectedOptions.indexOf(option);
      if (idx > -1) {
        this.selectedOptions.splice(idx, 1);
      } else {
        this.selectedOptions.push(option);
        if (this.toggleNone) {
          this.toggleNone = false;
        }
      }
    },

    resetOptions () {
      this.toggleNone = !this.toggleNone;
      if (this.toggleNone) {
        this.selectedOptions.length = 0;
      }
    },

    removePreferedOption (option) {
      // delete linked preference
      // yet we do not delete the complementoption, user can still do it later on dedicated screen
      const idx = this.preferedOptions.indexOf(option);
      this.preferedOptions.splice(idx, 1);

      // change to filter if later we decide that we can delete several preferences at once ?
      // not sure if several preferences with same wigo is supposed to happen here, but who knows
      const prefToDelete = this.scenarioPreferences.find(pre =>
        pre.wigo.some(opt => opt.id===option.id)
      );

      if (prefToDelete) {
        option.loading = true;
        scenarioService.deleteScenarioPreference(this.$route.params.id, prefToDelete.id).then(() => {
          this.$emit('raison-event', { type: 'success', messages: [this.$t('scenario.possibleOptionsValidated')] });
          this.scenarioPreferences.splice(this.scenarioPreferences.indexOf(prefToDelete), 1);
          this.scenario.extend = 'true';
        }).catch(err => {
          console.log(err);
          this.$emit('raison-event', { type: 'error', messages: [err] });
        }).finally(() => {
          option.loading = false;
        });
      } else {
        this.$emit('raison-event', { type: 'error', messages: [this.$t('scenario.preferenceNotFound')] });
      }
    },

    changeScenario (scenario) { // TODO: should we change this.$router.params.scenarioId without refreshing or something similar ?
      this.scenario = scenario;
      this.reinit();
      this.preferedOptions = this.getPreferedOptions(this.scenarioPreferences);
    },

    validateSelectedoptions () {
      this.callingApi = true;
      const preferences = this.selectedOptions
        .map(opt => {
          let preference = {
            name: 'added more options to an existing scenario',
            wigo: [{ id: opt.id }],
            scenario: this.scenario,
          };
          return preference;
        });

      scenarioService.createPreferences(this.$route.params.id, preferences)
        .then(response => {
          const createdPreferences = response.data;
          // here check resolved values and for scenarioPreferences, add them to existing array
          createdPreferences.forEach(pref =>
            this.scenarioPreferences.push(pref)
          )
          this.$emit('raison-event', { type: 'success', messages: [this.$t('scenario.possibleOptionsValidated')] });
          this.askForMoreScenarii = true;
          this.validatedOptions = [...this.selectedOptions];
          this.optionsAreValidated = true;
          this.selectedOptions = [];
        })
        .catch(err => {
          console.log(err);
          this.$emit('raison-event', { type: 'error', messages: [err] });
        })
        .finally(() => {
          this.callingApi = false;
        });
    },

    editValidatedOptions () {
      this.optionsAreValidated = false;
      this.preferedOptions.push(...this.validatedOptions);
      this.validatedOptions.length = 0;
    },

    loadOptions () {
      this.loadingOptions = true;
      optionService.getOptions(this.$route.params.id).then(res => {
        this.options = res.data;
      }).catch(err => {
        this.$emit('raison-event', { type: 'error', messages: [err] });
      }).finally(() => {
        this.loadingOptions = false;
      })
    },

    loadMinimalPreferences() {
      const projectId = this.$route.params.id;
      this.loadingScenarios = true;

      scenarioService.getAllPreferences(projectId)
        .then(response => {
          this.minimalPreferences = response.data
            .filter(pref => scenarioService.isMinimalPreference(pref, false));

          // Get minimal scenarios
          this.scenarios = list.removeDuplicateById(
            this.minimalPreferences
              .map(pref => pref.scenario));

          // Find selected scenario
          this.scenario = this.scenarios.find(sce => sce.id === this.$route.params.scenarioId);
          if (!this.scenario) {
            this.scenario = this.scenarios[0];
          }

          // Get all prefered options for this scenario
          this.preferedOptions = this.getPreferedOptions(this.scenarioPreferences);

        }).catch(err => {
          console.log(err);
          this.$emit('raison-event', { type: 'error', messages: [err] });
        }).finally(() => {
          this.loadingScenarios = false;
        });
    },

    getPreferedOptions(scenarioPreferences) {
      return _.uniqWith(scenarioPreferences.flatMap(pref => pref.wigo), (opt1, opt2) => opt1.id === opt2.id);
    },

    loadComplementOptions() {
      optionService.getAllConflictingOptions(this.$route.params.id).then(res => {
        this.complementOptions = res.data
      }).catch(err => {
        this.$emit('raison-event', { type: 'error', messages: [err] });
      });
    },

  },

  created () {
    this.loadMinimalPreferences();
    this.loadOptions();
    this.loadComplementOptions();
  },
};
</script>